// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.mqc-group-title {
  color: #1f2937;
  font-weight: 700;
  margin-bottom: 8px;
}

.mqc-table {
  margin-bottom: 0;
  table-layout: fixed;
}
.mqc-table th {
  background-color: #0066b2;
  color: #ffffff;
  font-weight: 600;
}
.mqc-table td {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mqc-col-material {
  width: 40%;
}

.mqc-col-sg {
  width: 15%;
}

.mqc-col-barcode {
  width: 20%;
}

.mqc-col-location {
  width: 25%;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-details/materials-qaqc/materials-qaqc.component.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAEA;EACE,cAAA;AADF;;AAIA;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;AADF;;AAIA;EACE,gBAAA;EACA,mBAAA;AADF;AAGE;EACE,yBChBU;EDiBV,cCUI;EDTJ,gBAAA;AADJ;AAIE;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AAFJ;;AAOA;EACE,UAAA;AAJF;;AAOA;EACE,UAAA;AAJF;;AAOA;EACE,UAAA;AAJF;;AAOA;EACE,UAAA;AAJF","sourcesContent":["@use '../../../../styles/colors' as colors;\n\n:host {\n  display: block;\n}\n\n.mqc-group-title {\n  color: #1f2937;\n  font-weight: 700;\n  margin-bottom: 8px;\n}\n\n.mqc-table {\n  margin-bottom: 0;\n  table-layout: fixed;\n\n  th {\n    background-color: colors.$medium-blue;\n    color: colors.$white;\n    font-weight: 600;\n  }\n\n  td {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n\n// Fixed column widths so long values truncate instead of reflowing the table\n.mqc-col-material {\n  width: 40%;\n}\n\n.mqc-col-sg {\n  width: 15%;\n}\n\n.mqc-col-barcode {\n  width: 20%;\n}\n\n.mqc-col-location {\n  width: 25%;\n}\n","$dark-blue: #0b2d71;\n$medium-blue: #0066b2;\n$light-blue: #009dd9;\n$dark-teal: #003653;\n$medium-teal: #00708c;\n$light-teal: #00b2bd;\n$dark-green: #444b0d;\n$medium-green: #769231;\n$light-green: #b2cc34;\n$dark-orange: #711b00;\n$medium-orange: #e5601f;\n$light-orange: #faab18;\n$dark-red: #58001c;\n$medium-red: #97002e;\n$light-red: #e21836;\n$lighter-red: rgb(247, 235, 239);\n$dark-purple: #3a0d36;\n$medium-purple: #751269;\n$light-purple: #ba3093;\n\n$dark-gray: #6b6d6f;\n$medium-gray: #8c8f93;\n$light-gray: #dbdcdd;\n$lighter-gray: #ECECEC;\n$lightest-gray: #f7f7f7; //alternative background-gray\n$lightest-gray2: #f3f3f3;\n\n$black: #000000;\n$white: #ffffff;\n$background-gray: #ededee;\n\n$highlight-blue: #E4F4FA; // for table highlights only\n$lighter-blue: #E4ECF2;\n$primary-blue: #007bff;\n$highlight-yellow: #E3F1A2;\n$highlight-peach: #FFE594;\n$highlight-neon: #FFA4C0;\n$success: #00708c;\n$warning: #faab18;\n$error: #97002e;"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
